/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminPasswordLoginDto,
  AuthLogoutEverywhere200,
  DeviceSessionResponse,
  LoginResponse,
  LogoutAllDto,
  LogoutDto,
  MeResponse,
  OtpRequestResponse,
  PatientRequestOtpDto,
  PatientVerifyOtpDto,
  RecoveryCodesResponse,
  RefreshDto,
  RequestOtpDto,
  StepUpResponse,
  SwitchClinicDto,
  TwoFactorChallengeDto,
  TwoFactorChallengeResponse,
  TwoFactorCodeDto,
  TwoFactorEnrolmentResponse,
  VerifyOtpDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * برای شمارهٔ داده‌شده یک کد یک‌بارمصرف می‌سازد و پیامک می‌کند. پاسخ هرگز نمی‌گوید شماره در سامانه ثبت شده است یا نه — همان پاسخ برای شمارهٔ ناشناس هم برمی‌گردد تا فهرست کاربران قابل استخراج نباشد.
 * @summary ارسال کد ورود
 */
export const authRequestOtp = (
    requestOtpDto: RequestOtpDto,
 signal?: AbortSignal
) => {


      return apiClient<OtpRequestResponse>(
      {url: `/api/v1/auth/otp/request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestOtpDto, signal
    },
      );
    }




export const getAuthRequestOtpMutationKey = () => ['authRequestOtp'] as const;

export const getAuthRequestOtpMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRequestOtp>>, TError,AuthRequestOtpMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authRequestOtp>>, TError,AuthRequestOtpMutationVariables, TContext> => {

const mutationKey = getAuthRequestOtpMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authRequestOtp>>, AuthRequestOtpMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authRequestOtp(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthRequestOtpMutationResult = NonNullable<Awaited<ReturnType<typeof authRequestOtp>>>
    export type AuthRequestOtpMutationBody = RequestOtpDto
    export type AuthRequestOtpMutationError = void
    export type AuthRequestOtpMutationVariables = {data: RequestOtpDto}

    /**
 * @summary ارسال کد ورود
 */
export const useAuthRequestOtp = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRequestOtp>>, TError,AuthRequestOtpMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authRequestOtp>>,
        TError,
        AuthRequestOtpMutationVariables,
        TContext
      > => {
      return useMutation(getAuthRequestOtpMutationOptions(options), queryClient);
    }
    /**
 * کد را می‌سنجد و در صورت درستی نشست باز می‌کند. اگر حساب ورود دومرحله‌ای فعال داشته باشد هیچ توکنی صادر نمی‌شود و به‌جای آن یک challengeToken کوتاه‌عمر برمی‌گردد که فقط /auth/two-factor/challenge آن را می‌پذیرد.
 * @summary تأیید کد و ورود
 */
export const authVerifyOtp = (
    verifyOtpDto: VerifyOtpDto,
 signal?: AbortSignal
) => {


      return apiClient<LoginResponse | TwoFactorChallengeResponse>(
      {url: `/api/v1/auth/otp/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyOtpDto, signal
    },
      );
    }




export const getAuthVerifyOtpMutationKey = () => ['authVerifyOtp'] as const;

export const getAuthVerifyOtpMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authVerifyOtp>>, TError,AuthVerifyOtpMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authVerifyOtp>>, TError,AuthVerifyOtpMutationVariables, TContext> => {

const mutationKey = getAuthVerifyOtpMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authVerifyOtp>>, AuthVerifyOtpMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authVerifyOtp(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthVerifyOtpMutationResult = NonNullable<Awaited<ReturnType<typeof authVerifyOtp>>>
    export type AuthVerifyOtpMutationBody = VerifyOtpDto
    export type AuthVerifyOtpMutationError = void
    export type AuthVerifyOtpMutationVariables = {data: VerifyOtpDto}

    /**
 * @summary تأیید کد و ورود
 */
export const useAuthVerifyOtp = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authVerifyOtp>>, TError,AuthVerifyOtpMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authVerifyOtp>>,
        TError,
        AuthVerifyOtpMutationVariables,
        TContext
      > => {
      return useMutation(getAuthVerifyOtpMutationOptions(options), queryClient);
    }
    /**
 * تنها راه ورود به admin.bookora.net. ورود پیامکی برای کنسول پذیرفته نمی‌شود. اگر حساب ورود دومرحله‌ای فعال کرده باشد، به‌جای توکن یک challengeToken برمی‌گردد.
 * @summary ورود به کنسول مدیریت با نام کاربری و رمز عبور
 */
export const authAdminPasswordLogin = (
    adminPasswordLoginDto: AdminPasswordLoginDto,
 signal?: AbortSignal
) => {


      return apiClient<LoginResponse | TwoFactorChallengeResponse>(
      {url: `/api/v1/auth/admin/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminPasswordLoginDto, signal
    },
      );
    }




export const getAuthAdminPasswordLoginMutationKey = () => ['authAdminPasswordLogin'] as const;

export const getAuthAdminPasswordLoginMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authAdminPasswordLogin>>, TError,AuthAdminPasswordLoginMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authAdminPasswordLogin>>, TError,AuthAdminPasswordLoginMutationVariables, TContext> => {

const mutationKey = getAuthAdminPasswordLoginMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authAdminPasswordLogin>>, AuthAdminPasswordLoginMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authAdminPasswordLogin(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthAdminPasswordLoginMutationResult = NonNullable<Awaited<ReturnType<typeof authAdminPasswordLogin>>>
    export type AuthAdminPasswordLoginMutationBody = AdminPasswordLoginDto
    export type AuthAdminPasswordLoginMutationError = void
    export type AuthAdminPasswordLoginMutationVariables = {data: AdminPasswordLoginDto}

    /**
 * @summary ورود به کنسول مدیریت با نام کاربری و رمز عبور
 */
export const useAuthAdminPasswordLogin = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authAdminPasswordLogin>>, TError,AuthAdminPasswordLoginMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authAdminPasswordLogin>>,
        TError,
        AuthAdminPasswordLoginMutationVariables,
        TContext
      > => {
      return useMutation(getAuthAdminPasswordLoginMutationOptions(options), queryClient);
    }
    /**
 * نیمهٔ دوم ورودِ حساب‌های دارای عامل دوم. کد برنامهٔ احرازهویت یا یکی از کدهای بازیابی پذیرفته می‌شود. موفقیت اینجا، نشست را برای خروجی‌های حساس هم «تازه‌تأییدشده» علامت می‌زند.
 * @summary تکمیل ورود دومرحله‌ای
 */
export const authCompleteTwoFactor = (
    twoFactorChallengeDto: TwoFactorChallengeDto,
 signal?: AbortSignal
) => {


      return apiClient<LoginResponse>(
      {url: `/api/v1/auth/two-factor/challenge`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: twoFactorChallengeDto, signal
    },
      );
    }




export const getAuthCompleteTwoFactorMutationKey = () => ['authCompleteTwoFactor'] as const;

export const getAuthCompleteTwoFactorMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authCompleteTwoFactor>>, TError,AuthCompleteTwoFactorMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authCompleteTwoFactor>>, TError,AuthCompleteTwoFactorMutationVariables, TContext> => {

const mutationKey = getAuthCompleteTwoFactorMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authCompleteTwoFactor>>, AuthCompleteTwoFactorMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authCompleteTwoFactor(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthCompleteTwoFactorMutationResult = NonNullable<Awaited<ReturnType<typeof authCompleteTwoFactor>>>
    export type AuthCompleteTwoFactorMutationBody = TwoFactorChallengeDto
    export type AuthCompleteTwoFactorMutationError = void
    export type AuthCompleteTwoFactorMutationVariables = {data: TwoFactorChallengeDto}

    /**
 * @summary تکمیل ورود دومرحله‌ای
 */
export const useAuthCompleteTwoFactor = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authCompleteTwoFactor>>, TError,AuthCompleteTwoFactorMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authCompleteTwoFactor>>,
        TError,
        AuthCompleteTwoFactorMutationVariables,
        TContext
      > => {
      return useMutation(getAuthCompleteTwoFactorMutationOptions(options), queryClient);
    }
    /**
 * توکن تازه‌سازی را می‌چرخاند و توکن دسترسی تازه می‌سازد. ادعاهای توکن دوباره از پایگاه داده حل می‌شوند، پس تغییر نقش یا مجوز در همین لحظه اعمال می‌شود. استفادهٔ دوباره از یک توکن مصرف‌شده کل نشست آن دستگاه را می‌بندد.
 * @summary تازه‌سازی توکن
 */
export const authRefresh = (
    refreshDto: RefreshDto,
 signal?: AbortSignal
) => {


      return apiClient<LoginResponse>(
      {url: `/api/v1/auth/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshDto, signal
    },
      );
    }




export const getAuthRefreshMutationKey = () => ['authRefresh'] as const;

export const getAuthRefreshMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRefresh>>, TError,AuthRefreshMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authRefresh>>, TError,AuthRefreshMutationVariables, TContext> => {

const mutationKey = getAuthRefreshMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authRefresh>>, AuthRefreshMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authRefresh(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof authRefresh>>>
    export type AuthRefreshMutationBody = RefreshDto
    export type AuthRefreshMutationError = void
    export type AuthRefreshMutationVariables = {data: RefreshDto}

    /**
 * @summary تازه‌سازی توکن
 */
export const useAuthRefresh = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRefresh>>, TError,AuthRefreshMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authRefresh>>,
        TError,
        AuthRefreshMutationVariables,
        TContext
      > => {
      return useMutation(getAuthRefreshMutationOptions(options), queryClient);
    }
    /**
 * توکن تازه‌سازی ارسالی را ابطال می‌کند و نشست همین دستگاه را می‌بندد؛ توکن دسترسی فعلی از همین لحظه پذیرفته نمی‌شود و دستگاه از فهرست نشست‌ها بیرون می‌رود. برای بستن دستگاه‌های دیگر از DELETE /auth/sessions استفاده کنید.
 * @summary خروج از همین دستگاه
 */
export const authLogout = (
    logoutDto: LogoutDto,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/auth/logout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: logoutDto, signal
    },
      );
    }




export const getAuthLogoutMutationKey = () => ['authLogout'] as const;

export const getAuthLogoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogout>>, TError,AuthLogoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authLogout>>, TError,AuthLogoutMutationVariables, TContext> => {

const mutationKey = getAuthLogoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authLogout>>, AuthLogoutMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authLogout(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof authLogout>>>
    export type AuthLogoutMutationBody = LogoutDto
    export type AuthLogoutMutationError = unknown
    export type AuthLogoutMutationVariables = {data: LogoutDto}

    /**
 * @summary خروج از همین دستگاه
 */
export const useAuthLogout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogout>>, TError,AuthLogoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authLogout>>,
        TError,
        AuthLogoutMutationVariables,
        TContext
      > => {
      return useMutation(getAuthLogoutMutationOptions(options), queryClient);
    }
    /**
 * هویت صاحب توکن، کلینیک فعال، مجوزهای مؤثر و فهرست کلینیک‌هایی که می‌تواند به آن‌ها سوئیچ کند. برای توکن کارکنان، activeClinicAccess و access هر عضویت می‌گویند کلینیک همین حالا اطلاعات تازه می‌پذیرد یا فقط‌خواندنی است، و دورهٔ آزمایشی چند روز دیگر تمام می‌شود — برای همهٔ نقش‌ها. پنل این را در بارگذاری اولیه می‌گیرد.
 * @summary مشخصات کاربر جاری
 */
export const authMe = (

 signal?: AbortSignal
) => {


      return apiClient<MeResponse>(
      {url: `/api/v1/auth/me`, method: 'GET', signal
    },
      );
    }




export const getAuthMeQueryKey = () => {
    return [
    `/api/v1/auth/me`
    ] as const;
    }


export const getAuthMeQueryOptions = <TData = Awaited<ReturnType<typeof authMe>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authMe>>> = ({ signal }) => authMe(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof authMe>>>
export type AuthMeQueryError = void


export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authMe>>,
          TError,
          Awaited<ReturnType<typeof authMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authMe>>,
          TError,
          Awaited<ReturnType<typeof authMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary مشخصات کاربر جاری
 */

export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * توکن تازه‌ای صادر می‌کند که به کلینیک خواسته‌شده محدود است. باید عضو فعال آن کلینیک باشید. نشست همین دستگاه باقی می‌ماند و فقط کلینیک فعالش عوض می‌شود، پس تازه‌سازی‌های بعدی هم در همان کلینیک می‌مانند.
 * @summary سوئیچ به کلینیک دیگر
 */
export const authSwitchClinic = (
    switchClinicDto: SwitchClinicDto,
 signal?: AbortSignal
) => {


      return apiClient<LoginResponse>(
      {url: `/api/v1/auth/switch-clinic`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: switchClinicDto, signal
    },
      );
    }




export const getAuthSwitchClinicMutationKey = () => ['authSwitchClinic'] as const;

export const getAuthSwitchClinicMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authSwitchClinic>>, TError,AuthSwitchClinicMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authSwitchClinic>>, TError,AuthSwitchClinicMutationVariables, TContext> => {

const mutationKey = getAuthSwitchClinicMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authSwitchClinic>>, AuthSwitchClinicMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authSwitchClinic(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthSwitchClinicMutationResult = NonNullable<Awaited<ReturnType<typeof authSwitchClinic>>>
    export type AuthSwitchClinicMutationBody = SwitchClinicDto
    export type AuthSwitchClinicMutationError = void
    export type AuthSwitchClinicMutationVariables = {data: SwitchClinicDto}

    /**
 * @summary سوئیچ به کلینیک دیگر
 */
export const useAuthSwitchClinic = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authSwitchClinic>>, TError,AuthSwitchClinicMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authSwitchClinic>>,
        TError,
        AuthSwitchClinicMutationVariables,
        TContext
      > => {
      return useMutation(getAuthSwitchClinicMutationOptions(options), queryClient);
    }
    /**
 * نشست‌های باز این کاربر با نام دستگاه، آخرین IP و آخرین فعالیت. ردیفی که current=true دارد همین دستگاهی است که درخواست را فرستاده.
 * @summary دستگاه‌های فعال
 */
export const authListSessions = (

 signal?: AbortSignal
) => {


      return apiClient<DeviceSessionResponse[]>(
      {url: `/api/v1/auth/sessions`, method: 'GET', signal
    },
      );
    }




export const getAuthListSessionsQueryKey = () => {
    return [
    `/api/v1/auth/sessions`
    ] as const;
    }


export const getAuthListSessionsQueryOptions = <TData = Awaited<ReturnType<typeof authListSessions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authListSessions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthListSessionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authListSessions>>> = ({ signal }) => authListSessions(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authListSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthListSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof authListSessions>>>
export type AuthListSessionsQueryError = unknown


export function useAuthListSessions<TData = Awaited<ReturnType<typeof authListSessions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authListSessions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authListSessions>>,
          TError,
          Awaited<ReturnType<typeof authListSessions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthListSessions<TData = Awaited<ReturnType<typeof authListSessions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authListSessions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authListSessions>>,
          TError,
          Awaited<ReturnType<typeof authListSessions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthListSessions<TData = Awaited<ReturnType<typeof authListSessions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authListSessions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary دستگاه‌های فعال
 */

export function useAuthListSessions<TData = Awaited<ReturnType<typeof authListSessions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authListSessions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthListSessionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * همهٔ نشست‌ها را می‌بندد و tokenVersion را یک واحد بالا می‌برد، پس توکن‌های دسترسی صادرشدهٔ قبلی هم بلافاصله بی‌اعتبار می‌شوند — نه اینکه تا پایان عمرشان کار کنند. با keepCurrentDevice=true دستگاه فعلی باز می‌ماند.
 * @summary خروج از همهٔ دستگاه‌ها
 */
export const authLogoutEverywhere = (
    logoutAllDto: LogoutAllDto,
 signal?: AbortSignal
) => {


      return apiClient<AuthLogoutEverywhere200>(
      {url: `/api/v1/auth/sessions`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: logoutAllDto, signal
    },
      );
    }




export const getAuthLogoutEverywhereMutationKey = () => ['authLogoutEverywhere'] as const;

export const getAuthLogoutEverywhereMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogoutEverywhere>>, TError,AuthLogoutEverywhereMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authLogoutEverywhere>>, TError,AuthLogoutEverywhereMutationVariables, TContext> => {

const mutationKey = getAuthLogoutEverywhereMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authLogoutEverywhere>>, AuthLogoutEverywhereMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authLogoutEverywhere(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthLogoutEverywhereMutationResult = NonNullable<Awaited<ReturnType<typeof authLogoutEverywhere>>>
    export type AuthLogoutEverywhereMutationBody = LogoutAllDto
    export type AuthLogoutEverywhereMutationError = unknown
    export type AuthLogoutEverywhereMutationVariables = {data: LogoutAllDto}

    /**
 * @summary خروج از همهٔ دستگاه‌ها
 */
export const useAuthLogoutEverywhere = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogoutEverywhere>>, TError,AuthLogoutEverywhereMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authLogoutEverywhere>>,
        TError,
        AuthLogoutEverywhereMutationVariables,
        TContext
      > => {
      return useMutation(getAuthLogoutEverywhereMutationOptions(options), queryClient);
    }
    /**
 * نشست و همهٔ توکن‌های تازه‌سازی آن دستگاه را ابطال می‌کند. فقط نشست‌های خودِ کاربر قابل بستن‌اند؛ شناسهٔ نشست کاربر دیگر به‌صورت SESSION_NOT_FOUND پاسخ می‌گیرد.
 * @summary بستن یک دستگاه
 */
export const authRevokeSession = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/auth/sessions/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getAuthRevokeSessionMutationKey = () => ['authRevokeSession'] as const;

export const getAuthRevokeSessionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRevokeSession>>, TError,AuthRevokeSessionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authRevokeSession>>, TError,AuthRevokeSessionMutationVariables, TContext> => {

const mutationKey = getAuthRevokeSessionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authRevokeSession>>, AuthRevokeSessionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  authRevokeSession(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthRevokeSessionMutationResult = NonNullable<Awaited<ReturnType<typeof authRevokeSession>>>

    export type AuthRevokeSessionMutationError = void
    export type AuthRevokeSessionMutationVariables = {id: string}

    /**
 * @summary بستن یک دستگاه
 */
export const useAuthRevokeSession = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRevokeSession>>, TError,AuthRevokeSessionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authRevokeSession>>,
        TError,
        AuthRevokeSessionMutationVariables,
        TContext
      > => {
      return useMutation(getAuthRevokeSessionMutationOptions(options), queryClient);
    }
    /**
 * کد یک‌بارمصرف برای ورود به اپلیکیشن بیمار می‌فرستد. پاسخ برای شماره‌ای که هیچ پرونده‌ای ندارد دقیقاً همان است — وگرنه می‌شد با امتحان کردن شماره‌ها فهمید چه کسی بیمار کدام کلینیک است.
 * @summary ارسال کد ورود بیمار
 */
export const patientAuthRequestOtp = (
    patientRequestOtpDto: PatientRequestOtpDto,
 signal?: AbortSignal
) => {


      return apiClient<OtpRequestResponse>(
      {url: `/api/v1/patient-auth/otp/request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientRequestOtpDto, signal
    },
      );
    }




export const getPatientAuthRequestOtpMutationKey = () => ['patientAuthRequestOtp'] as const;

export const getPatientAuthRequestOtpMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientAuthRequestOtp>>, TError,PatientAuthRequestOtpMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientAuthRequestOtp>>, TError,PatientAuthRequestOtpMutationVariables, TContext> => {

const mutationKey = getPatientAuthRequestOtpMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientAuthRequestOtp>>, PatientAuthRequestOtpMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patientAuthRequestOtp(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientAuthRequestOtpMutationResult = NonNullable<Awaited<ReturnType<typeof patientAuthRequestOtp>>>
    export type PatientAuthRequestOtpMutationBody = PatientRequestOtpDto
    export type PatientAuthRequestOtpMutationError = void
    export type PatientAuthRequestOtpMutationVariables = {data: PatientRequestOtpDto}

    /**
 * @summary ارسال کد ورود بیمار
 */
export const usePatientAuthRequestOtp = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientAuthRequestOtp>>, TError,PatientAuthRequestOtpMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientAuthRequestOtp>>,
        TError,
        PatientAuthRequestOtpMutationVariables,
        TContext
      > => {
      return useMutation(getPatientAuthRequestOtpMutationOptions(options), queryClient);
    }
    /**
 * کد را می‌سنجد، حساب را در صورت نبود می‌سازد و توکن با مخاطب PATIENT صادر می‌کند. در همین لحظه تطبیق شماره با پرونده‌های همهٔ کلینیک‌ها دوباره اجرا می‌شود، پس کلینیکی که هفتهٔ پیش در آن پرونده تشکیل شده امروز در فهرست دیده می‌شود.
 * @summary تأیید کد و ورود بیمار
 */
export const patientAuthVerifyOtp = (
    patientVerifyOtpDto: PatientVerifyOtpDto,
 signal?: AbortSignal
) => {


      return apiClient<LoginResponse | TwoFactorChallengeResponse>(
      {url: `/api/v1/patient-auth/otp/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientVerifyOtpDto, signal
    },
      );
    }




export const getPatientAuthVerifyOtpMutationKey = () => ['patientAuthVerifyOtp'] as const;

export const getPatientAuthVerifyOtpMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientAuthVerifyOtp>>, TError,PatientAuthVerifyOtpMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientAuthVerifyOtp>>, TError,PatientAuthVerifyOtpMutationVariables, TContext> => {

const mutationKey = getPatientAuthVerifyOtpMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientAuthVerifyOtp>>, PatientAuthVerifyOtpMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patientAuthVerifyOtp(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientAuthVerifyOtpMutationResult = NonNullable<Awaited<ReturnType<typeof patientAuthVerifyOtp>>>
    export type PatientAuthVerifyOtpMutationBody = PatientVerifyOtpDto
    export type PatientAuthVerifyOtpMutationError = void
    export type PatientAuthVerifyOtpMutationVariables = {data: PatientVerifyOtpDto}

    /**
 * @summary تأیید کد و ورود بیمار
 */
export const usePatientAuthVerifyOtp = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientAuthVerifyOtp>>, TError,PatientAuthVerifyOtpMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientAuthVerifyOtp>>,
        TError,
        PatientAuthVerifyOtpMutationVariables,
        TContext
      > => {
      return useMutation(getPatientAuthVerifyOtpMutationOptions(options), queryClient);
    }
    /**
 * نیمهٔ دوم ورودِ بیمارانی که روی حساب کاربری‌شان عامل دوم فعال است — مثلاً پزشکی که در کلینیک خودش هم پرونده دارد. کد برنامهٔ احرازهویت یا یکی از کدهای بازیابی پذیرفته می‌شود و توکن صادرشده حتماً از نوع بیمار است.
 * @summary تکمیل ورود دومرحله‌ای بیمار
 */
export const patientAuthCompleteTwoFactor = (
    twoFactorChallengeDto: TwoFactorChallengeDto,
 signal?: AbortSignal
) => {


      return apiClient<LoginResponse>(
      {url: `/api/v1/patient-auth/two-factor/challenge`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: twoFactorChallengeDto, signal
    },
      );
    }




export const getPatientAuthCompleteTwoFactorMutationKey = () => ['patientAuthCompleteTwoFactor'] as const;

export const getPatientAuthCompleteTwoFactorMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientAuthCompleteTwoFactor>>, TError,PatientAuthCompleteTwoFactorMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientAuthCompleteTwoFactor>>, TError,PatientAuthCompleteTwoFactorMutationVariables, TContext> => {

const mutationKey = getPatientAuthCompleteTwoFactorMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientAuthCompleteTwoFactor>>, PatientAuthCompleteTwoFactorMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patientAuthCompleteTwoFactor(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientAuthCompleteTwoFactorMutationResult = NonNullable<Awaited<ReturnType<typeof patientAuthCompleteTwoFactor>>>
    export type PatientAuthCompleteTwoFactorMutationBody = TwoFactorChallengeDto
    export type PatientAuthCompleteTwoFactorMutationError = void
    export type PatientAuthCompleteTwoFactorMutationVariables = {data: TwoFactorChallengeDto}

    /**
 * @summary تکمیل ورود دومرحله‌ای بیمار
 */
export const usePatientAuthCompleteTwoFactor = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientAuthCompleteTwoFactor>>, TError,PatientAuthCompleteTwoFactorMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientAuthCompleteTwoFactor>>,
        TError,
        PatientAuthCompleteTwoFactorMutationVariables,
        TContext
      > => {
      return useMutation(getPatientAuthCompleteTwoFactorMutationOptions(options), queryClient);
    }
    /**
 * همان چرخش توکن پنل کلینیک، اما پاسخ فقط وقتی برگردانده می‌شود که مخاطب توکن تازه PATIENT باشد.
 * @summary تازه‌سازی توکن بیمار
 */
export const patientAuthRefresh = (
    refreshDto: RefreshDto,
 signal?: AbortSignal
) => {


      return apiClient<LoginResponse>(
      {url: `/api/v1/patient-auth/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshDto, signal
    },
      );
    }




export const getPatientAuthRefreshMutationKey = () => ['patientAuthRefresh'] as const;

export const getPatientAuthRefreshMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientAuthRefresh>>, TError,PatientAuthRefreshMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientAuthRefresh>>, TError,PatientAuthRefreshMutationVariables, TContext> => {

const mutationKey = getPatientAuthRefreshMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientAuthRefresh>>, PatientAuthRefreshMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patientAuthRefresh(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientAuthRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof patientAuthRefresh>>>
    export type PatientAuthRefreshMutationBody = RefreshDto
    export type PatientAuthRefreshMutationError = void
    export type PatientAuthRefreshMutationVariables = {data: RefreshDto}

    /**
 * @summary تازه‌سازی توکن بیمار
 */
export const usePatientAuthRefresh = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientAuthRefresh>>, TError,PatientAuthRefreshMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientAuthRefresh>>,
        TError,
        PatientAuthRefreshMutationVariables,
        TContext
      > => {
      return useMutation(getPatientAuthRefreshMutationOptions(options), queryClient);
    }
    /**
 * توکن تازه‌سازی ارسالی را ابطال می‌کند و نشست همین دستگاه را می‌بندد؛ توکن دسترسی فعلی از همین لحظه پذیرفته نمی‌شود.
 * @summary خروج بیمار
 */
export const patientAuthLogout = (
    logoutDto: LogoutDto,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/patient-auth/logout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: logoutDto, signal
    },
      );
    }




export const getPatientAuthLogoutMutationKey = () => ['patientAuthLogout'] as const;

export const getPatientAuthLogoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientAuthLogout>>, TError,PatientAuthLogoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientAuthLogout>>, TError,PatientAuthLogoutMutationVariables, TContext> => {

const mutationKey = getPatientAuthLogoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientAuthLogout>>, PatientAuthLogoutMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patientAuthLogout(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientAuthLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof patientAuthLogout>>>
    export type PatientAuthLogoutMutationBody = LogoutDto
    export type PatientAuthLogoutMutationError = unknown
    export type PatientAuthLogoutMutationVariables = {data: LogoutDto}

    /**
 * @summary خروج بیمار
 */
export const usePatientAuthLogout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientAuthLogout>>, TError,PatientAuthLogoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientAuthLogout>>,
        TError,
        PatientAuthLogoutMutationVariables,
        TContext
      > => {
      return useMutation(getPatientAuthLogoutMutationOptions(options), queryClient);
    }
    /**
 * هویت صاحب توکن به‌همراه هر کلینیکی که برای همین شماره پرونده‌ای دارد و بیمار پیوندش را قطع نکرده است. پیوندها هنگام ورود از روی چکیدهٔ کور شماره (phoneHash) ساخته می‌شوند؛ این مسیر فقط می‌خواندشان تا یک GET پرتکرار روی همان ردیف‌ها ننویسد.
 * @summary حساب بیمار و کلینیک‌هایش
 */
export const patientAuthMe = (

 signal?: AbortSignal
) => {


      return apiClient<MeResponse>(
      {url: `/api/v1/patient-auth/me`, method: 'GET', signal
    },
      );
    }




export const getPatientAuthMeQueryKey = () => {
    return [
    `/api/v1/patient-auth/me`
    ] as const;
    }


export const getPatientAuthMeQueryOptions = <TData = Awaited<ReturnType<typeof patientAuthMe>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientAuthMe>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientAuthMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientAuthMe>>> = ({ signal }) => patientAuthMe(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientAuthMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientAuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof patientAuthMe>>>
export type PatientAuthMeQueryError = void


export function usePatientAuthMe<TData = Awaited<ReturnType<typeof patientAuthMe>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientAuthMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientAuthMe>>,
          TError,
          Awaited<ReturnType<typeof patientAuthMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientAuthMe<TData = Awaited<ReturnType<typeof patientAuthMe>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientAuthMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientAuthMe>>,
          TError,
          Awaited<ReturnType<typeof patientAuthMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientAuthMe<TData = Awaited<ReturnType<typeof patientAuthMe>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientAuthMe>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary حساب بیمار و کلینیک‌هایش
 */

export function usePatientAuthMe<TData = Awaited<ReturnType<typeof patientAuthMe>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientAuthMe>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientAuthMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * یک راز تازه می‌سازد، آن را رمزنگاری‌شده ذخیره می‌کند و نشانی otpauth را برمی‌گرداند تا پنل QR بسازد. تا وقتی مرحلهٔ تأیید انجام نشود، عامل دوم فعال نیست — پس بستن ناگهانی صفحه، حسابی به‌جا نمی‌گذارد که کسی نتواند واردش شود. اجرای دوباره پیش از تأیید، راز قبلی را جایگزین می‌کند.
 * @summary شروع فعال‌سازی ورود دومرحله‌ای
 */
export const twoFactorEnrol = (

 signal?: AbortSignal
) => {


      return apiClient<TwoFactorEnrolmentResponse>(
      {url: `/api/v1/auth/two-factor/enrol`, method: 'POST', signal
    },
      );
    }




export const getTwoFactorEnrolMutationKey = () => ['twoFactorEnrol'] as const;

export const getTwoFactorEnrolMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twoFactorEnrol>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof twoFactorEnrol>>, TError,void, TContext> => {

const mutationKey = getTwoFactorEnrolMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twoFactorEnrol>>, void> = () => {


          return  twoFactorEnrol()
        }






  return  { mutationFn, ...mutationOptions }}

    export type TwoFactorEnrolMutationResult = NonNullable<Awaited<ReturnType<typeof twoFactorEnrol>>>

    export type TwoFactorEnrolMutationError = void


    /**
 * @summary شروع فعال‌سازی ورود دومرحله‌ای
 */
export const useTwoFactorEnrol = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twoFactorEnrol>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof twoFactorEnrol>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getTwoFactorEnrolMutationOptions(options), queryClient);
    }
    /**
 * با یک کد زندهٔ برنامهٔ احرازهویت ثابت می‌کند که راز درست ثبت شده، سپس عامل دوم را فعال می‌کند و کدهای بازیابی را می‌سازد. کدهای بازیابی فقط همین یک بار نمایش داده می‌شوند؛ روی سرور تنها چکیدهٔ آن‌ها می‌ماند.
 * @summary تأیید و فعال‌سازی ورود دومرحله‌ای
 */
export const twoFactorVerify = (
    twoFactorCodeDto: TwoFactorCodeDto,
 signal?: AbortSignal
) => {


      return apiClient<RecoveryCodesResponse>(
      {url: `/api/v1/auth/two-factor/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: twoFactorCodeDto, signal
    },
      );
    }




export const getTwoFactorVerifyMutationKey = () => ['twoFactorVerify'] as const;

export const getTwoFactorVerifyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twoFactorVerify>>, TError,TwoFactorVerifyMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof twoFactorVerify>>, TError,TwoFactorVerifyMutationVariables, TContext> => {

const mutationKey = getTwoFactorVerifyMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twoFactorVerify>>, TwoFactorVerifyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  twoFactorVerify(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TwoFactorVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof twoFactorVerify>>>
    export type TwoFactorVerifyMutationBody = TwoFactorCodeDto
    export type TwoFactorVerifyMutationError = void
    export type TwoFactorVerifyMutationVariables = {data: TwoFactorCodeDto}

    /**
 * @summary تأیید و فعال‌سازی ورود دومرحله‌ای
 */
export const useTwoFactorVerify = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twoFactorVerify>>, TError,TwoFactorVerifyMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof twoFactorVerify>>,
        TError,
        TwoFactorVerifyMutationVariables,
        TContext
      > => {
      return useMutation(getTwoFactorVerifyMutationOptions(options), queryClient);
    }
    /**
 * برای مسیرهایی که تأیید تازه می‌خواهند (خروجی گرفتن از پروندهٔ بیماران و گزارش‌های مالی). با یک کد معتبر، این نشست برای مدت مشخصی «تازه‌تأییدشده» علامت می‌خورد. اگر پاسخ ۴۰۳ با کد TWO_FACTOR_REQUIRED گرفتید، اینجا کد بفرستید و دوباره تلاش کنید.
 * @summary تأیید مجدد برای عملیات حساس
 */
export const twoFactorStepUp = (
    twoFactorCodeDto: TwoFactorCodeDto,
 signal?: AbortSignal
) => {


      return apiClient<StepUpResponse>(
      {url: `/api/v1/auth/two-factor/step-up`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: twoFactorCodeDto, signal
    },
      );
    }




export const getTwoFactorStepUpMutationKey = () => ['twoFactorStepUp'] as const;

export const getTwoFactorStepUpMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twoFactorStepUp>>, TError,TwoFactorStepUpMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof twoFactorStepUp>>, TError,TwoFactorStepUpMutationVariables, TContext> => {

const mutationKey = getTwoFactorStepUpMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twoFactorStepUp>>, TwoFactorStepUpMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  twoFactorStepUp(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TwoFactorStepUpMutationResult = NonNullable<Awaited<ReturnType<typeof twoFactorStepUp>>>
    export type TwoFactorStepUpMutationBody = TwoFactorCodeDto
    export type TwoFactorStepUpMutationError = void
    export type TwoFactorStepUpMutationVariables = {data: TwoFactorCodeDto}

    /**
 * @summary تأیید مجدد برای عملیات حساس
 */
export const useTwoFactorStepUp = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twoFactorStepUp>>, TError,TwoFactorStepUpMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof twoFactorStepUp>>,
        TError,
        TwoFactorStepUpMutationVariables,
        TContext
      > => {
      return useMutation(getTwoFactorStepUpMutationOptions(options), queryClient);
    }
    /**
 * کد زنده (یا یکی از کدهای بازیابی) لازم است: بدون آن، یک توکن دسترسی دزدیده‌شده برای برداشتن همان کنترلی کافی بود که وجودش برای مقابله با توکن دزدیده‌شده است. راز و همهٔ کدهای بازیابی پاک می‌شوند.
 * @summary غیرفعال‌سازی ورود دومرحله‌ای
 */
export const twoFactorDisable = (
    twoFactorCodeDto: TwoFactorCodeDto,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/auth/two-factor/disable`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: twoFactorCodeDto, signal
    },
      );
    }




export const getTwoFactorDisableMutationKey = () => ['twoFactorDisable'] as const;

export const getTwoFactorDisableMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twoFactorDisable>>, TError,TwoFactorDisableMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof twoFactorDisable>>, TError,TwoFactorDisableMutationVariables, TContext> => {

const mutationKey = getTwoFactorDisableMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twoFactorDisable>>, TwoFactorDisableMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  twoFactorDisable(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TwoFactorDisableMutationResult = NonNullable<Awaited<ReturnType<typeof twoFactorDisable>>>
    export type TwoFactorDisableMutationBody = TwoFactorCodeDto
    export type TwoFactorDisableMutationError = void
    export type TwoFactorDisableMutationVariables = {data: TwoFactorCodeDto}

    /**
 * @summary غیرفعال‌سازی ورود دومرحله‌ای
 */
export const useTwoFactorDisable = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twoFactorDisable>>, TError,TwoFactorDisableMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof twoFactorDisable>>,
        TError,
        TwoFactorDisableMutationVariables,
        TContext
      > => {
      return useMutation(getTwoFactorDisableMutationOptions(options), queryClient);
    }
    /**
 * کل مجموعه را جایگزین می‌کند و کدهای قبلی را بی‌اعتبار. «تولید دوبارهٔ یک کد» عمداً وجود ندارد: مجموعه‌ای که بخشی از آن لو رفته، از یک مجموعهٔ کاملاً تازه بدتر است. نیازمند کد زندهٔ برنامهٔ احرازهویت.
 * @summary ساخت دوبارهٔ کدهای بازیابی
 */
export const twoFactorRegenerateRecoveryCodes = (
    twoFactorCodeDto: TwoFactorCodeDto,
 signal?: AbortSignal
) => {


      return apiClient<RecoveryCodesResponse>(
      {url: `/api/v1/auth/two-factor/recovery-codes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: twoFactorCodeDto, signal
    },
      );
    }




export const getTwoFactorRegenerateRecoveryCodesMutationKey = () => ['twoFactorRegenerateRecoveryCodes'] as const;

export const getTwoFactorRegenerateRecoveryCodesMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twoFactorRegenerateRecoveryCodes>>, TError,TwoFactorRegenerateRecoveryCodesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof twoFactorRegenerateRecoveryCodes>>, TError,TwoFactorRegenerateRecoveryCodesMutationVariables, TContext> => {

const mutationKey = getTwoFactorRegenerateRecoveryCodesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twoFactorRegenerateRecoveryCodes>>, TwoFactorRegenerateRecoveryCodesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  twoFactorRegenerateRecoveryCodes(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TwoFactorRegenerateRecoveryCodesMutationResult = NonNullable<Awaited<ReturnType<typeof twoFactorRegenerateRecoveryCodes>>>
    export type TwoFactorRegenerateRecoveryCodesMutationBody = TwoFactorCodeDto
    export type TwoFactorRegenerateRecoveryCodesMutationError = void
    export type TwoFactorRegenerateRecoveryCodesMutationVariables = {data: TwoFactorCodeDto}

    /**
 * @summary ساخت دوبارهٔ کدهای بازیابی
 */
export const useTwoFactorRegenerateRecoveryCodes = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twoFactorRegenerateRecoveryCodes>>, TError,TwoFactorRegenerateRecoveryCodesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof twoFactorRegenerateRecoveryCodes>>,
        TError,
        TwoFactorRegenerateRecoveryCodesMutationVariables,
        TContext
      > => {
      return useMutation(getTwoFactorRegenerateRecoveryCodesMutationOptions(options), queryClient);
    }
